// Sales Getters

export const getSalesList = state => {
  return state.salesList
}

export const getSaleInfo = state => {
  return state.saleInfo
}

export const getReportUnClosedSalesCount = state => {
  return state.reportUnclosedSalesCount
}

export const getReportUnPaidSalesCount = state => {
  return state.reportUnPaidSalesCount
}

export const getUnClosedSalesCount = state => {
  return state.unclosedSalesCount
}

export const getUnPaidSalesCount = state => {
  return state.unPaidSalesCount
}

export const getReceiveTypes = state => {
  return state.receiveTypes
}
